import React, { CSSProperties, useEffect, useRef, useState } from 'react'
import { DownArrow } from 'shared-components/Components/CustomIcons/DownArrow/web'
import './styles.less'
import { FiltersIcon } from 'shared-components/Components/CustomIcons/FiltersIcon/web'
import { CloseIcon } from 'shared-components/Components/CustomIcons/CloseIcon/web'

type Props = {
  children: React.ReactNode
  label: string
  customWidth?: number
  positionRight?: boolean
  buttonRef?:React.MutableRefObject<any>
  customHeight?:number | string
  modal?:boolean,
  style?:CSSProperties,
  clossers?:React.MutableRefObject<any>[],
  active?:boolean,
  visible?:boolean,
  setVisible?:(value:boolean)=>void,
  onCancelFilter?:()=>void,
  scrollable?: boolean
}


const InputFilterBox = (props: Props) => {
  const boxRef = useRef(null)
  const modalRef = useRef(null)
  const dropdownRef = useRef(null);
  const dropdownContentRef = useRef(null);
  const [showOptions, setShowOptions] = useState<boolean>(false)
  const [dropDownAlign, setDropDownAlign] = useState<'left' | 'right'>()
  const useVisibleState = typeof props.visible !== 'undefined'

  const handleClickOutside = (event) => {
    if(!props.modal) {
      const clickedElement = event.target;
      const isInsideBackdrop = clickedElement.closest(".modal-backdrop");
      if (isInsideBackdrop) {
        return;
      }

      if (boxRef.current && (!boxRef.current.contains(clickedElement) || clickedElement.classList.contains("inputFilterBox__content--close"))) {
        closeModal();
      }
      if (modalRef.current && props.modal &&  modalRef.current == clickedElement) {
        closeModal();
      }
    }
  };

  const handleKeyPress = (event) => {
    if (event.keyCode === 27) { //esc
      closeModal();
    }
  };

  const submitHandleClick = (event)=>{
    if(props.buttonRef && props.buttonRef.current.contains(event.target)) closeModal();
    if(props.clossers && props.clossers.length > 0) {
      props.clossers.forEach(ref => {
        if(ref?.current?.contains(event.target)) closeModal();
      })
    }
    else return
  }

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    document.addEventListener('click', submitHandleClick);
    document.addEventListener('keydown', handleKeyPress);

    return () => {
      document.removeEventListener('click', handleClickOutside);
      document.removeEventListener('click', submitHandleClick);
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  useEffect(() => {
    if (showOptions && dropdownRef.current && dropdownContentRef.current) {
      const rect = dropdownRef.current.getBoundingClientRect();
      const distanceFromRight = window.innerWidth - rect.right;
      const widthElement = dropdownContentRef.current.offsetWidth;

      if (distanceFromRight < widthElement) {
        setDropDownAlign('right');
      } else {
        setDropDownAlign('left');
      }
    }
  }, [showOptions]);

  const handleButtonClick=()=>{
    showOptions ? closeModal() : openModal();
  }

  const openModal =() => {
    if(props.modal) document.body.style.overflow = "hidden";
    if(props.modal && boxRef?.current) boxRef.current.querySelector('.filter-body')?.scrollTo(0, 0);
    setShowOptions(true);
    if(typeof(props.setVisible) === 'function') props.setVisible(true);
  }

  const closeModal =() => {
    if(props.modal) document.body.style.overflow = "auto";
    setShowOptions(false);
    document?.body?.classList?.remove('no-scroll');
  }

  const customStyles:CSSProperties = {
    maxWidth: props.customWidth && props.customWidth,
    minHeight: props.customHeight ? props.customHeight : "unset",
    minWidth: props.customWidth && props.customWidth,
    [dropDownAlign]: 0,
    transformOrigin: `top ${dropDownAlign}`,
  }

  return (
		<div className={"inputFilterBox " + (props.active ? 'active':'')} style={props.style ?? {}} ref={boxRef}>
			<div
				className={`inputFilterBox__label ${showOptions ? "inputActive" : ""}`}
				aria-label={props.modal?'Abrir modal de filtros': 'Abrir filtros'}
				onClick={() => handleButtonClick()}
        ref={dropdownRef}
      >
				<p>{props.label}</p>
				{props.modal ? 
          <FiltersIcon /> :
          props.active && props.onCancelFilter ? 
            <button className="inputFilterBox__label--reset" onClick={props.onCancelFilter}>
              <CloseIcon width={12} />
            </button>
            : <DownArrow />
        }
			</div>

      {showOptions ?
        props.modal ? (
          useVisibleState && ! props.visible ? <></> : <div
            ref={modalRef}
            onClick={()=>{closeModal()}}
            className={`inputFilterBox__content fullModal closable ${
              showOptions ? "showContentFilter" : ""
            }`}>
            <div onClick={(event)=>{event.stopPropagation()}}>
              {props.children}
            </div>
          </div>
        ) : (
          <div
            ref={dropdownContentRef}
            className={`inputFilterBox__content ${showOptions ? "showContentFilter" : ""}`}
            style={customStyles}
          >
            <div className={`${props.scrollable ? "scrollable" : ""}`}>
              {props.children}
            </div>
          </div>
        ) : null
      }
		</div>
  );
}



export default InputFilterBox